import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { ComponentPropsWithoutRef } from "react";

import { t } from "@/i18n-js/instance";
import { anchorClassNames } from "@/react/helpers/cssAnchorHelpers";

export const SidebarWrapper = ({
  children,
  className,
  ...rest
}: ComponentPropsWithoutRef<"div">) => (
  <aside
    aria-label={t("left_sidebar")}
    className={classNames(
      anchorClassNames("standard-layout-v2__sidebar"),
      className,
    )}
    data-testid="standard-layout-v2-sidebar"
    {...rest}
  >
    <nav>{children}</nav>
  </aside>
);
